import React, { Component } from 'react';
import ReactModal from 'react-modal';
import { WidgetHelper } from '../WidgetHelper';

interface IRushHourModalWidgetProps {
    imgSrc: string;
    linkLabel: string;
}

interface IRushHourModalWidgetState {
    showModal: boolean;
}

export class RushHourModalWidget extends Component<
    IRushHourModalWidgetProps,
    IRushHourModalWidgetState
> {
    constructor(props: IRushHourModalWidgetProps) {
        super(props);
        this.state = { showModal: false };
    }

    handleOpenModal = () => {
        this.setState({ showModal: true });
    };

    handleCloseModal = () => {
        this.setState({ showModal: false });
    };

    render() {
        return (
            <>
                <button
                    type="button"
                    className="link-icon"
                    onClick={this.handleOpenModal}
                >
                    <i className="icon-clock"></i>
                    {this.props.linkLabel}
                </button>
                <ReactModal
                    isOpen={this.state.showModal}
                    contentLabel={this.props.linkLabel}
                    className="modal__dialog"
                    overlayClassName="modal__backdrop"
                    onRequestClose={this.handleCloseModal}
                    closeTimeoutMS={200}
                    ariaHideApp={false}
                    bodyOpenClassName="dialog--open"
                >
                    <button
                        className="modal__close btn-no-look"
                        onClick={this.handleCloseModal}
                    >
                        <i className="icon-cross"></i>
                        <span className="sr-only">Fermer</span>
                    </button>
                    <div className="modal__content">
                        <img src={this.props.imgSrc} alt="rush hour image" />
                    </div>
                </ReactModal>
            </>
        );
    }
}

WidgetHelper.register(RushHourModalWidget, 'rush-hour-modal-widget');
